import { useQuery } from '@tanstack/react-query';

import { savedFiltersOptions } from './savedFilters.options';

export const useSavedFiltersQuery = () => useQuery(savedFiltersOptions.list());
